// client/src/components/marketer/cps/modals/SettleCompleteModal.js
import React from 'react';

function SettleCompleteModal({ open, onClose, settlementInfo }) {
  if (!open) return null;

  return (
    <div className="mbm-overlay" style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      justifyContent: 'center',
      zIndex: 1400 // SettleModal(1200), SettleConfirmModal(1300) 위에 표시
    }} onClick={(e) => {
      e.stopPropagation();
      onClose();
    }}>
      <div
        className="mb-card mbm"
        style={{
          width: '90vw',
          maxWidth: 400,
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div style={{
          background: 'linear-gradient(135deg, #0fb37a 0%, #059669 100%)',
          padding: '32px 24px',
          textAlign: 'center',
          color: 'white',
          position: 'relative'
        }}>
          <div style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
            fontSize: 48
          }}>
            ✓
          </div>
          <h3 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            정산이 완료되었습니다!
          </h3>
        </div>

        {/* 본문 */}
        <div style={{ padding: '28px 24px', textAlign: 'center', flex: 1 }}>
          <p style={{
            fontSize: 15,
            color: 'var(--mb-text-body)',
            lineHeight: 1.6,
            marginBottom: 20
          }}>
            인플루언서에게 포인트가 정상적으로 지급되었습니다.
          </p>

          {settlementInfo && (
            <div style={{
              background: '#f0fdf4',
              border: '1px solid #86efac',
              borderRadius: 'var(--mb-card-radius)',
              padding: '16px',
              marginBottom: 20,
              textAlign: 'left'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 13, color: 'var(--mb-text-sub)' }}>결산 회차</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#166534' }}>
                  {settlementInfo.roundNumber}회차
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 13, color: 'var(--mb-text-sub)' }}>지급 인원</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#166534' }}>
                  {settlementInfo.targetCount}명
                </span>
              </div>
              <div style={{ borderTop: '1px dashed #86efac', paddingTop: 12, marginTop: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#166534' }}>
                    총 지급액
                  </span>
                  <span style={{ fontSize: 18, fontWeight: 700, color: '#0fb37a' }}>
                    {settlementInfo.totalAmount.toLocaleString()} pt
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* 버튼 */}
        <div className="mbm-foot" style={{
          padding: '20px 24px',
          borderTop: '1px solid var(--mb-border-color)',
          background: '#f6f8fb',
          marginTop: 0
        }}>
          <button
            onClick={onClose}
            className="mb-btn mb-btn-primary"
            style={{
              padding: '12px 40px',
              fontSize: 15,
              fontWeight: 600
            }}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default SettleCompleteModal;

